import { defineCustomElement } from 'vue'

import ExtendedPicker from './components/ExtendedPicker'
import Viewer2 from './components/Viewer2.vue'

const Viewer2CustomElement = defineCustomElement(Viewer2)

customElements.define('monocle-picker', ExtendedPicker)
customElements.define('monocle-viewer2', Viewer2CustomElement)
